import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOrderMSServiceDocument } from '~/types/document/models'

export const {
  getDocumentListData: getOrderMSServiceDocumentListData,
  getDocumentDataById: getOrderMSServiceDocumentDataById,
  getDocumentListDataByParentId: getOrderMSServiceDocumentListDataByOMSSId,
} = makeDocumentMockData<IOrderMSServiceDocument>({
  entityName: 'orderMSService',
  storageKeyPrefix: 'ordermsservice',
})
